<app-products-header-banner></app-products-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center">
  <h2 class="font-bold text-3xl website-heading">Varroc Connect App</h2>
  <span class="text-l text-center w-full mt-5">Available for download on your Android and iOS
    smartphones empowers you to take
    control of your vehicle like never before.</span>
  <span class="font-light text-2xl website-light-heading">Drive Smarter & Better </span>
  <span class="text-l text-justify w-full">Varroc Connect isn't just an app it's your
    reliable road companion. Transform your driving experience with this all-in-one app that puts the power of your
    vehicle at your fingertips. Secure and easy to download from your smartphone's app store, it unlocks a new level of
    control and intelligence for your car.</span>

  <!-- Image container with absolute positioned buttons -->
  <div class="relative w-full md:w-[50%] mt-10">
    <img [src]="Images.VC_APP_BANNER" alt="Varroc Connect App – Drive Smarter and Better" class="w-full">

    <!-- Absolutely positioned app store buttons -->
    <div
      class="absolute bottom-5 md:bottom-20 left-1/2 transform -translate-x-1/2 flex justify-center items-center gap-3 sm:gap-5 w-max">
      <a href="{{ANDROID_APP_LINK}}" target="_blank"
        rel="noopener noreferrer" class="transition-transform  w-full automative_application_play_store_download_btn">
        <img [src]="Images.PLAY_STORE_BUTTON" alt="Get it on Google Play" class="h-10  md:h-12 automative_application_play_store_download_btn_img">
      </a>
      <a href="{{IOS_APP_LINK}}" target="_blank" rel="noopener noreferrer"
        class="transition-transform  w-full automative_application_app_store_download_btn">
        <img [src]="Images.APP_STORE_BUTTON" alt="Download on the App Store" class="h-10  md:h-12 automative_application_app_store_download_btn_img">
      </a>
    </div>
  </div>
</div>

<div class="container mx-auto mt-16 px-5 w-11/12 flex flex-col justify-center items-center gap-3">
  <!-- Row 1 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_SAFETY" alt="Safety Alerts for Secure Driving" class="size-10">
      <span><strong>Safety First:</strong> Varroc Connect prioritizes your safety with alerts for potential hazards,
        ensuring a secure journey.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_WATCH" alt="Real-Time Driving Insights Icon" class="size-10">
      <span><strong>Real-Time Insights:</strong> Instant feedback on driving habits, including fuel efficiency (or EV
        range), acceleration, and braking.</span>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_CAR" alt="Vehicle Health Monitoring Icon" class="size-10">
      <span><strong>Vehicle Health Assessment:</strong> Monitor performance, get maintenance alerts, and prevent
        unexpected breakdowns.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.ICON_ZOOM" alt="Trip Tracking and Driving Analysis Icon" class="size-10">
      <span><strong>Trip Tracking & Analysis:</strong> Track trips, analyze driving patterns, and replay
        journeys.</span>
    </div>
  </div>
</div>